import apiEndpoints from '../../../api';
import { clean, listParams, bodyOf, getReq, writeReq } from './vmsHttp';

/* ------------------------------------------------------- activity logs */

export const getActivityLogsListReq = (action) => {
    const d = action.data;
    return getReq(apiEndpoints.SOCIETY_GET_VMS_ACTIVITY_LOGS_API, listParams(d, {
        activity_type: d?.activityType,
        visitor_id: d?.visitorId,
        visit_id: d?.visitId,
        from_date: d?.fromDate,
        to_date: d?.toDate,
    }), 'Failed to load activity logs');
};

// Despite the name this returns JSON, not a file: a normal success envelope
// whose data is a flat array, hard-capped at 10 000 rows with no flag saying
// the cap was hit. The file is built client-side; the caller narrows the date
// range. It also takes no activity_type filter.
export const exportActivityLogsReq = (action) => {
    const d = action.data;
    return getReq(apiEndpoints.SOCIETY_EXPORT_VMS_ACTIVITY_LOGS_API, clean({
        society_id: d?.societyId,
        from_date: d?.fromDate,
        to_date: d?.toDate,
    }), 'Failed to export activity logs');
};

/* ------------------------------------------------------------ settings */

// society_id is optional in Joi but required in practice — without it the
// endpoint answers 400 "Society ID is required" rather than misbehaving.
// Creates the row with defaults on first read, so this never 404s.
export const getVmsSettingsReq = (action) =>
    getReq(apiEndpoints.SOCIETY_GET_VMS_SETTINGS_API,
        clean({ society_id: action.data?.societyId }), 'Failed to load VMS settings');

// Upsert: creates the row if missing, patches it otherwise.
export const updateVmsSettingsReq = (action) =>
    writeReq('put', apiEndpoints.SOCIETY_UPDATE_VMS_SETTINGS_API, bodyOf(action.data),
        'Settings saved', 'Failed to save settings');
